/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建/编辑页
 */
'use strict';
angular.module("atlasModule", ['atlasDetailModule', 'atlasRouterModule']).
controller('atlasCtrl', ['$scope', '$element', '$filter', '$state', '$stateParams', '$q', '$compile', 'httpService', 'modalDialog', '$validation', 'localStorageService', '$timeout', "editPictureService", function($scope, $element, $filter, $state, $stateParams, $q, $compile, httpService, modalDialog, $validation, localStorageService, $timeout, editPictureService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channels: [],
            imageArrs: [],
            selectedImage: [],
            articleTitle: '', //文章标题
            canDrag: false,
            textareaList: {}
        };
    }

    function initData() {
        getPubWayInfo().then(function() {
            return initList();
        });
    }
    /**
     * [selectImage description] 选中图片项的集合
     * @return {[type]} [description]
     */
    $scope.selectImage = function(item) {
        if ($scope.status.selectedImage.indexOf(item.id) > -1) {
            $scope.status.selectedImage.splice($scope.status.selectedImage.indexOf(item.id), 1);
        } else {
            $scope.status.selectedImage.push(item.id);
        }
    };
    /**
     * [moveUploadImg description]图集上传图片列表拖拽
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    $scope.moveUploadImg = function(index) {
        $scope.status.imageArrs.splice(index, 1);

    };
    /**
     * [initList description] 初始化表单数据
     * @return {[type]} [description]
     */
    function initList() {
        var deffer = $q.defer();
        if (!!$stateParams.id) {
            $scope.status.hide = false;
            getDraftInfo().then(function(result) {
                $scope.status.articleTitle = result.articeInfo.articleTitle;
                $scope.status.imageArrs = JSON.parse(result.articeInfo.pictures);
                $scope.selectedChannel = result.chnlsAndTags;
                $scope.articleStatus = result.articeInfo.articleStatus;
                $scope.$broadcast('selectedChannel', $scope.selectedChannel);
                deffer.resolve();
            });
        }
        return deffer.promise;
    }
    /**
     * [getDraftInfo description] 查询稿件信息
     * @return {[type]} [description]
     */
    function getDraftInfo() {
        var deffer = $q.defer();
        var params = {
            articleId: $stateParams.id
        };
        httpService.http("/mcnww/web/pgcArticle/findById.do", params, "get").then(function(result) {
            deffer.resolve(result);
        });
        return deffer.promise;
    }
    /**
     * [getPubWay description] 获取发布渠道相关信息
     * @return {[type]} [description]
     */
    function getPubWayInfo() {
        var deffer = $q.defer();
        httpService.http("/mcnww/web/channel/querySignChnlList.do", "", "post").then(function(data) {
            $scope.channels = data.data;
            $scope.$broadcast('channels', $scope.channels);
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [uploadPic description] 一次上传多张图片
     * @return {[type]} [description]
     */
    $scope.uploadPices = function($files) {
        if ($files) {
            if ($files.length == 0) return;
            let warnOnce=false;
            for (let i = $files.length - 1; i >= 0; i--) {
                if ($files[i].size / 1024 / 1024 > 20) {
                   	warnOnce=true;
                    $files.splice(i, 1);
                }
            };
            if(warnOnce){
            	modalDialog.alertType("", "图片不能大于20M", "warning", "confirm");
            }
            var index;
            $files.forEach(function(file) {
                uploadPic(file).then(function(res) {
                    var obj = {};
                    obj.imageUrl = angular.globalConfig.pictureServer + res.url;
                    obj.instruction = "";
                    //给图片加上一个唯一的id 便于后面的修改和编辑
                    obj.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                    $scope.status.imageArrs.push(obj);
                    if (!index) {
                        index = $scope.status.imageArrs.length;
                        $timeout(function() {
                            var html = $("html");
                            var tr = $("table tbody tr")[index - 1];
                            html.animate({ scrollTop: html.scrollTop() + $(tr).offset().top - html.offset().top }, 500);
                        })
                    }
                }).catch(function(error) {
                    modalDialog.alertType("", error.message, "error", false);
                })
            })
        }
    };
    /**
     * [uploadPic description] 上传渠道封面图片
     * @return {[type]} [description]
     */
    $scope.uploadPic = function($files, $file, $newFiles, item, attribute) {
        if (!$file) return;
        uploadPic($file).then(function(res) {
            editPictureService.newCropperAppForImage(angular.globalConfig.pictureServer + res.url, $scope.status.channels[0].channelPicSize).then(function(data) {
                if (data.success == '上传成功') {
                    item[attribute] = angular.globalConfig.pictureServer + data.imgSrc;
                } else {
                    modalDialog.success("图片上传失败", "error", false, function() {});
                }
            }, function(res) {

            });

        }).catch(function(error) {
            modalDialog.alertType("", error.message, "error", false);
        })
    };

    /**
     * [save description] 保存或发布文章
     * @return {[type]} [description]
     */
    $scope.save = function(ispub) {
        validator().then(function() {
            return saveArticle(ispub);
        }).then(function(data) {
            if (data.success) {
                var newId = data.id;
                localStorage.imageArrs = []; //清空本地数据
                reFreshListPage();
                modalDialog.success((ispub ? "投稿" : "保存稿件") + "成功", "success", false, function() {
                    if (ispub) {
                        window.close();
                    }
                    $state.go("atlas", {
                        id: newId,
                        type: 5
                    }, {
                        reload: "atlas"
                    });
                }, function() {}, '', 'left0');
            }
        });
    };
    /**
     * [saveArticle description] 保存文章
     * @return {[type]} [description]
     */
    function saveArticle(ispub) {
        var defer = $q.defer();
        var channelData = getSelectChannel();
        if (channelData.length == 0) {
            modalDialog.alertType("请至少选择一个发布渠道", "", "warning", "confirm");
            var html = $("html");
            var div = $(".dingweidiv")[0];
            html.animate({ scrollTop: html.scrollTop() + $(div).offset().top - html.offset().top }, 1000);
            defer.reject({ success: false });
        } else {
            var d = $scope.list;
            var boo = ispub == 0 ? false : true;
            var params = {
                articleType: '1',
                articleTitle: $scope.status.articleTitle,
                pictures: JSON.stringify($scope.status.imageArrs),
                channels: JSON.stringify(getSelectChannel()),
                bPub: boo
            };
            //新建的时候不传id
            if ($stateParams.id != 0) {
                params.id = $stateParams.id
            }
            httpService.http("/mcnww/web/pgcArticle/saveOtherArticle.do", params, "post").then(function(result) {
                defer.resolve(result);
            });
        }
        return defer.promise;
    }
    /**
     * [validator description] 表单校验
     * @return {[type]} [description]
     */
    function validator() {
        var deffer = $q.defer();
        $validation.validate($scope.imagesForm).success(function() {
            deffer.resolve();
        }).error(function(result) {
            //表单校验手动触发
            $scope.imagesForm.$valid = false;
            $scope.imagesForm.$invalid = true;
            angular.invalidPosition($scope.imagesForm, $element);
        });
        return deffer.promise;
    }
    /**
     * [getSelectChannel description] 获取选取的渠道以及上传的图片
     * @return {[type]} [description]
     */
    function getSelectChannel() {
        var data = [];
        var channels = $scope.channels;
        for (var i = 0; i < channels.length; i++) {
            var _c = channels[i];
            if (_c.checked) {
                var o = {
                    channelId: _c.id, //渠道ID
                    channelName: _c.channelName, //渠道名称 
                    coverType: _c.coverType, //封面类型-单图 
                }
                var imgArr = [];
                if (_c.coverType == 0) {
                    imgArr[0] = _c.pic1;
                } else if (_c.coverType == 1) {
                    imgArr[0] = _c.pic1;
                    imgArr[1] = _c.pic2;
                    imgArr[2] = _c.pic3;
                }
                o.coverImg = imgArr; //封面图片数组
                data.push(o);
            }
        }
        return data;
    }
    /**
     * [deleteByQuery description] 批量删除
     * @return {[type]} [description]
     */
    $scope.deleteByQuery = function() {
        modalDialog.confirmModal("删除", "确定删除选中的图片吗？", function() {
            $scope.status.selectedImage.forEach(function(id) {
                $scope.status.imageArrs = $scope.status.imageArrs.filter(function(val) {
                    return val.id !== id
                })
            })
            $scope.status.selectedImage = []; //清空选项
        });
    }
    /**
     * [editImage description] 编辑图片
     * @return {[type]} [description]
     */
    $scope.editImage = function(item) {
        editPictureService.newCropperAppForImage(angular.globalConfig.pictureServer + item.imageUrl, "").then(function(data) {
            $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                if (val.id === item.id) {
                    val.imageUrl = data.imgSrc;
                    val.instruction = item.instruction;
                    //给图片加上一个唯一的id 便于后面的修改和编辑
                    val.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                }
                return val;
            })
        });
    }
    /**
     * [replaceIamge description] 更换图片
     * @return {[type]} [description]
     */
    $scope.repalceImage = function($files, item) {
        if ($files && $files.length == 0) return;
        uploadPic($files[0]).then(function(res) {
            $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                if (val.id === item.id) {
                    val.imageUrl = res.url;
                    val.instruction = item.instruction;
                    //给图片加上一个唯一的id 便于后面的修改和编辑
                    val.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                }
                return val;
            })
        }).catch(function(error) {
            modalDialog.alertType("", error.message, "error", false);
        })
    }
    /**
     * [syncInstruction description] 同步所有说明
     * @return {[type]} [description]
     */
    $scope.syncInstruction = function(item) {
        modalDialog.confirmModal("同步", "确定同步所有说明吗？", function() {
            if (item.instruction == "") {
                return;
            }
            $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                val.instruction = item.instruction;
                return val;
            })
        });
    }
    /** 拖拽成功触发方法
     *   index 拖拽后落下时的元素的序号（下标）
     *   obj 被拖动数据对象
     */
    $scope.dropComplete = function(index, obj) {
        var idx = $scope.status.imageArrs.indexOf(obj);
        $scope.status.imageArrs[idx] = $scope.status.imageArrs[index];
        $scope.status.imageArrs[index] = obj;

    };
    /**
     * [reFreshList description] 刷新列表页
     * @return {[type]} [description]
     */
    function reFreshListPage() {
        localStorageService.set("refresh", Math.random());
    }

    /**
     * [uploadPic description] 上传图片的公共方法
     * @return {[type]} [description]
     */
    function uploadPic(file) {
        var defer = $q.defer();
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }
        var fd = new FormData();
        var name = file.name;
        fd.append("file", file);
        fd.append("name", name);
        $.ajax({
            url: '/mcnww/upload/image.do',
            type: 'POST',
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            async: false,
            data: fd,
            processData: false,
            contentType: false,
            success: function(data) {
                if (data.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data);
                }
            }
        });
        return defer.promise;
    }
}]);